import CloseIcon from "assets/images/CloseIcon";
import {common as stringsCommon, refillPlacedModal as strings} from "strings";

import Button from "components/Button";
import PageTitle from "components/PageTitle";
import StyledModal from "components/StyledModal";

import * as models from "liberty-core/api/models";

import styles from "./RefillPlacedModal.module.css";

type Medication = {
  imageUrl?: string;
  name?: string;
  scriptNumber: number;
};

type RefillPlacedModalProps = {
  medicationList: Medication[];
  refillResponse: models.RefillResponse[];
  visible: boolean;
  onClickClose: () => void;
};

export default function RefillPlacedModal(props: RefillPlacedModalProps) {
  return (
    <StyledModal className={styles.modal} visible={props.visible}>
      <div className={styles.container}>
        <div className={styles.detailsContainer}>
          <div className={styles.headerSection}>
            <PageTitle className={styles.header}>
              {strings.refillsPlaced}
            </PageTitle>
            <button
              className={styles.close}
              onClick={() => {
                return props.onClickClose();
              }}
            >
              <CloseIcon />
            </button>
          </div>
          <div className={styles.section}>
            {props.refillResponse.map((r) => {
              const medication = props.medicationList.find(
                (m) => m.scriptNumber === r.scriptNumber,
              );
              const rxName =
                medication?.name ?? `${stringsCommon.rxNum} ${r.scriptNumber}`;
              return (
                <div
                  key={r.scriptNumber}
                  className={styles.statusSectionContent}
                >
                  {`\u2022 ${rxName} - ${
                    r.success ? strings.success : strings.failure
                  }: ${r.message}`}
                </div>
              );
            })}
          </div>
          <Button className={styles.closeButton} onClick={props.onClickClose}>
            {stringsCommon.close}
          </Button>
        </div>
      </div>
    </StyledModal>
  );
}
